import React from 'react';

interface CTASectionProps {
  onGetPreApproved?: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({ onGetPreApproved }) => {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to Get Your Dream Car?
        </h2>
        <p className="text-xl text-blue-100 mb-4 max-w-3xl mx-auto">
          Get pre-approved in minutes and drive away today.
        </p>
        <div className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400 border-4 border-yellow-300 rounded-2xl p-10 mb-12 max-w-4xl mx-auto shadow-2xl">
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8">
            <div className="text-8xl sm:text-9xl font-black text-blue-900">$500</div>
            <div className="text-center sm:text-left">
              <div className="font-black text-blue-900 text-5xl sm:text-6xl mb-3">CASH BACK!</div>
              <div className="font-bold text-blue-800 text-2xl sm:text-3xl mb-2">Get $500 CAD cash when you purchase a car from us!</div>
              <div className="text-blue-700 text-base sm:text-lg">*Terms and conditions apply. Offer valid for purchases from our inventory.</div>
            </div>
          </div>
        </div>
        
        <div className="flex justify-center mb-8">
          <button 
            onClick={onGetPreApproved}
            className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-300 transition-colors shadow-lg"
          >
            Get Pre-Approved Now
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <div className="text-3xl font-bold text-yellow-400 mb-2">5 Min</div>
            <div className="text-blue-100">Application Time</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-yellow-400 mb-2">Same Day</div>
            <div className="text-blue-100">Drive Away</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-yellow-400 mb-2">No Fees</div>
            <div className="text-blue-100">Hidden Charges</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
